import { Variant } from '@kizi/core-components';
import p from './paragraphs';

const basic: Variant = {
  lineHeight: '24px',
  borderRadius: '8px',
  borderStyle: 'solid',
  borderWidth: '1px',
  cursor: 'pointer',
  fontFamily: 'button',
  fontWeight: 1,
  height: 48,
  px: 24,
  py: 16,
  textAlign: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  '&.disabled': {
    opacity: 0.3,
  },
};

const expandProductCard: Variant = {
  // ...basic,
  bg: 'white',
  border: 'none',
  borderRadius: '200px',
  boxShadow: 'default',
  padding: '4px 16px',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 400,
  color: 'main.2',
  cursor: 'pointer',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  bottom: '-14px',
};

const moreInformation: Variant = {
  bg: 'white',
  border: 'none',
  borderRadius: '30px',
  color: 'main.1',
  cursor: 'pointer',
  boxShadow: 'default',
  fontSize: 2,
  fontWeight: 1,
  lineHeight: 2,
  px: 3,
  py: 1,
  '&:active:enabled': {
    '&:not(.disabled)': {
      bg: 'white',
      border: 'none',
      color: 'main.2',
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      bg: 'white',
      border: 'none',
      color: 'main.1',
    },
  },
  '&.disabled': {
    color: 'second.0',
  },
};

const moreInformationDark: Variant = {
  ...moreInformation,
  color: 'main.2',
  px: 4,
  '&:hover:enabled': {
    color: 'main.2',
  },
};

const primary: Variant = {
  ...basic,
  background: '#FFC60D',
  boxShadow:
    '0px 0px 2px rgba(78, 90, 126, 0.08), 0px 4px 12px rgba(62, 72, 101, 0.14)',
  border: 'none',
  color: 'main.2',
  fontSize: 3,
  px: 24,
  py: 16,
  width: ['100%', 'fit-content'],
  '&:disabled': {
    color: '#A4A7AE',
    background: '#E9EAEB',
    boxShadow: 'none',
  },
  '&:focus:enabled': {
    '&:not(.disabled)': {
      background: '#FFD54D',
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      background: '#FFD54D',
    },
  },
};

const primarySmall: Variant = {
  ...primary,
  fontSize: [0, null, 2],
  height: '',
  px: '16px',
  py: '4px',
  width: 'fit-content',
};

// TODO Dont know yet if yellow button will be global for all butons
const productCardPrimary: Variant = {
  ...basic,
  background: '#FFC60D',
  color: 'main.2',
  lineHeight: '24px',
  fontSize: '16px',
  padding: '8px 16px',
  borderColor: '#FFC60D',
  boxShadow: '0px 4px 12px 0px #3E486524, 0px 0px 2px 0px #4E5A7E14',

  '&:disabled': {
    opacity: 0.3,
    boxShadow: 'none',
  },
  '&:focus:enabled': {
    '&:not(.disabled)': {
      opacity: 0.8,
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      opacity: 0.8,
    },
  },
};

const secondary: Variant = {
  ...basic,
  bg: 'white',
  border: 'none',
  boxShadow:
    '0px 0px 2px rgba(78, 90, 126, 0.08), 0px 4px 12px rgba(62, 72, 101, 0.14)',
  color: 'main.2',
  fontSize: 3,
  px: 24,
  py: 16,
  '&:disabled': {
    background: 'second.0',
    color: 'main.5',
    boxShadow: 'none',
  },
  '&:focus:enabled': {
    '&:not(.disabled)': {
      // borderColor: 'main.2',
      boxShadow: 'none',
      color: 'main.2',
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      // borderColor: 'main.1',
      color: 'main.5',
      boxShadow:
        '0px 0px 2px rgba(78, 90, 126, 0.08), 0px 4px 12px rgba(62, 72, 101, 0.14)',
    },
  },
};

const secondaryBlue: Variant = {
  ...basic,
  border: '1px dashed',
  borderColor: '#007BFF',
  bg: 'white',
  boxShadow:
    '0px 0px 2px 0px rgba(78, 90, 126, 0.08), 0px 4px 12px 0px rgba(62, 72, 101, 0.14)',
  color: 'main.1',
  fontSize: 3,
  px: 24,
  py: 16,
  '&:disabled': {
    opacity: 0.3,
    boxShadow: 'none',
  },
  '&:focus:enabled': {
    '&:not(.disabled)': {
      // borderColor: 'main.2',
      boxShadow: 'none',
      color: 'main.1',
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      // borderColor: 'main.1',
      color: 'main.1',
      boxShadow:
        '0px 0px 2px rgba(78, 90, 126, 0.08), 0px 4px 12px rgba(62, 72, 101, 0.14)',
    },
  },
};

const secondarySmall: Variant = {
  ...secondary,
  fontSize: [0, null, 2],
  height: '',
  px: 3,
  py: 1,
  width: 'fit-content',
};

const secondaryMedium: Variant = {
  ...basic,
  bg: 'white',
  borderColor: 'main.1',
  color: 'main.1',
  '&:active:enabled': {
    '&:not(.disabled)': {
      borderColor: 'main.2',
      color: 'main.2',
    },
  },
  '&:hover:enabled': {
    '&:not(.disabled)': {
      borderColor: 'main.1',
      color: 'main.1',
    },
  },
  fontSize: 2,
  height: '31px',
  px: 3,
  width: 'fit-content',
  marginTop: 3,
  display: 'block',
};

const secondaryTransparent: Variant = {
  ...secondary,
  bg: 'transparent',
};

const transparent: Variant = {
  border: 'none',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  fontSize: [2, null, 3],
  lineHeight: 2,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const applyPageNavigation: Variant = {
  ...transparent,
  color: 'main.2',
  display: 'inline-block',
  '&:not(:last-child)': {
    '::after': {
      content: '""',
      height: '1px',
      width: '40px',
      bg: 'supplementary.6',
      display: 'inline-block',
      verticalAlign: 'middle',
      mr: 3,
      ml: 3,
    },
  },
  '&:disabled': {
    color: 'supplementary.6',
  },
};

const transparentWithIcon: Variant = {
  ...transparent,
  '> svg': {
    fill: 'main.1',
  },
};

const transparentDefaultColor: Variant = {
  ...transparent,
  color: 'main.3',
};

const transparentMedium: Variant = {
  border: 'none',
  display: ['flex', 'flex'],
  bg: 'transparent',
  cursor: 'pointer',
  fontSize: [2, 3],
  lineHeight: ['21px', '24px'],
  p: 0,
  ml: ['auto', 3, 3],
  mb: ['-10px', null],
  height: '0px',
  color: 'supplementary.0',
};

const transparentSmall: Variant = {
  ...p.footnoteRegular,
  border: 'none',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  lineHeight: 2,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const transparentSmallImportant: Variant = {
  ...p.footnoteImportant,
  border: 'none',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  lineHeight: 2,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const transparentToExtraSmall: Variant = {
  ...p.bodyRegularToCaption,
  border: 'none',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  lineHeight: 2,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const transparentExtraSmall: Variant = {
  ...p.captionRegularSmall,
  border: 'none',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  m: 0,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const transparentExtraSmallImportant: Variant = {
  ...p.captionImportantSmall,
  border: 'none',
  borderRadius: 'initial',
  bg: 'transparent',
  color: 'main.1',
  cursor: 'pointer',
  lineHeight: '0.875rem',
  m: 0,
  p: 0,
  width: 'fit-content',
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.2',
      textDecorationLine: 'underline',
    },
  },
};

const promotionItem: Variant = {
  ...transparent,
  fontWeight: 500,
  fontSize: 2,
  color: '#0B428E',
};

const promotionItemLarge: Variant = {
  ...promotionItem,
  color: 'text',
  fontSize: 2,
  fontWeight: 1,
};

const info: Variant = {
  bg: 'transparent',
  border: 'none',
  color: 'main.1',
  cursor: 'pointer',
  fontWeight: 1,
  mt: 6,
  p: 0,
  '&:active:enabled, &:hover:enabled': {
    '&:not(.disabled)': {
      border: 'none',
      bg: 'transparent',
      color: 'main.1',
    },
  },
};

const primaryHeading: Variant = {
  ...primary,
  fontSize: 3,
  fontFamily: 'heading',
};

const submitModalWithSteps: Variant = {
  ...primary,
  width: 'fit-content',
};

const addMore = {
  border: '1px dashed',
  borderColor: 'second.1',
  borderRadius: '8px',
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 3,
  background: 'transparent',
  cursor: 'pointer',
};

const stickyHeaderAddMore: Variant = {
  border: 'none',
  display: 'block',
  background: 'transparent',
  margin: 'auto',
  padding: 0,
};

const sideSubmitButton = {
  ...primary,
  mt: '8px',
  display: 'flex',
  alignItems: 'center',
  padding: '8px 16px',
  width: '100%',
  justifyContent: 'center',
};

const personalDataEditIcon = {
  display: 'flex',
  padding: '4px',
  borderRadius: '80px',
  background: 'linear-gradient(315deg, #03AD7D 11.93%, #08C98F 81.44%)',
  boxShadow:
    '0px 4px 8px 0px rgba(62, 72, 101, 0.05), 0px 2px 4px 0px rgba(78, 90, 126, 0.10), 0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
  border: 'none',
};

const deleteButton = {
  ...basic,
  height: 'initial',
  p: 0,
  gap: 0,
  lineHeight: '24px',
  bg: 'white',
  color: 'supplementary.0',
  fontSize: '14px',
  fontWeight: 500,
  border: 'none',
  boxShadow: 'none',

  '&:hover:enabled:not(.disabled)': {
    color: 'supplementary.0',
  },
};

const buttonVariants = {
  info,
  moreInformation,
  moreInformationDark,
  primary,
  primarySmall,
  secondary,
  secondaryTransparent,
  secondaryMedium,
  secondarySmall,
  submitModalWithSteps,
  transparent,
  transparentMedium,
  transparentSmall,
  transparentSmallImportant,
  transparentToExtraSmall,
  transparentExtraSmall,
  transparentExtraSmallImportant,
  promotionItem,
  promotionItemLarge,
  primaryHeading,
  addMore,
  transparentDefaultColor,
  applyPageNavigation,
  transparentWithIcon,
  secondaryBlue,
  stickyHeaderAddMore,
  sideSubmitButton,
  personalDataEditIcon,
  deleteButton,
  expandProductCard,
  productCardPrimary,
};

export default buttonVariants;
